import React, { Component } from 'react'
import styled from 'styled-components'

class FullWidthSection extends Component {
  render() {
    const { children, mobileHide, mobileBg } = this.props
    return (
      <FullWidthSectionContainer style={{ background: this.props.bgColor }}>
        <section className="mobile">{children}</section>
        <section className="web">{children}</section>
      </FullWidthSectionContainer>
    )
  }
}

export default FullWidthSection

const FullWidthSectionContainer = styled.div`
  padding: 100px 0;
  .mobile {
    display: none;
  }
  .web {
    display: block;
  }

  @media screen and (max-width: 768px) {
    .mobile {
      display: block;
    }
    .web {
      display: none;
    }
    padding: 50px 0;
  }

  section {
    margin: auto;
    max-width: 1200px;
  }
`



// WEBPACK FOOTER //
// ./src/components/UI/FullWidthSection.jsx